import DocumentSettings from "./DocumentSettings";
import PortalDocument from "./PortalDocument";
import ViewerType from "./DataType";
import Container from "./Container";
import {Attachment} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";

export default abstract class AbstractContainer implements Container {
	private readonly _settings: DocumentSettings;
	private _loaded: boolean;
	private _data: any;

	constructor(portalDocument?: PortalDocument) {
		this._settings = DocumentSettings.fromDocument(portalDocument);
		this._loaded = false;
	}

	public get loaded(): boolean {
		return this._loaded;
	}

	public set loaded(value: boolean) {
		this._loaded = value;
	}

	public get data(): any {
		return this._data;
	}

	public set data(value: any) {
		this._data = value;
	}

	public get settings() {
		return this._settings;
	}

	abstract getNumberOfPages(data: any): Promise<number>;

	abstract loadViewerData(portalDocument: PortalDocument, attachment?: Attachment): Promise<any>;

	abstract clean(): void;

	abstract getType(): ViewerType;
}